import { render, staticRenderFns } from "./UpgradeCheckoutErrorModal.vue?vue&type=template&id=0b3d1830"
import script from "./UpgradeCheckoutErrorModal.vue?vue&type=script&lang=ts"
export * from "./UpgradeCheckoutErrorModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports